import i18n from './index'

/**
 * Traduce il nome di un crop_operation, survey_schema o survey_schema_plant
 * (name, vocabolario per-organizzazione — vedi docs/todo/I18N_TODO.md)
 * rispettando la lingua corrente. Se il nome non è presente nel vocabolario
 * schemaVocab (né lingua corrente né fallback 'it') — es. schemi custom
 * creati via AdminDbmngView — ritorna il valore originale così com'è
 * arrivato dal DB.
 */
export function translateSchemaName(name) {
  if (!name) return name
  const messages = i18n.global.messages.value
  const locale = i18n.global.locale.value
  const direct = messages[locale]?.schemaVocab?.[name]
  if (direct !== undefined) return direct
  const fallback = messages.it?.schemaVocab?.[name]
  return fallback !== undefined ? fallback : name
}
